import { FormArray, FormControl } from '@angular/forms';
import { ISurtitle } from 'src/app/core/models/i-surtitle';
import { ITypedSelectListItem } from 'src/app/shared-form-sections/interfaces/i-typed-select-list-item';

export function handleTagAddedAsSurtitle(
  typedTagToAdd: ITypedSelectListItem,
  surtitleControl: FormArray<FormControl<ISurtitle>>
) {
  const newSurtitle: ISurtitle = {
    id: typedTagToAdd.tag.id.toString(),
    name: typedTagToAdd.tag.displayName,
    displayText: typedTagToAdd.tag.displayName,
    surtitleType: typedTagToAdd.tagType,
  };

  surtitleControl.clear();
  surtitleControl.push(new FormControl(newSurtitle));
}

export function handleTagRemoved(
  typedTagToRemove: ITypedSelectListItem,
  typedTagArray: FormArray,
  surtitleControl: FormArray<FormControl<ISurtitle>>
) {
  if (typedTagArray) {
    const index = typedTagArray.controls.findIndex(
      (control) =>
        control.value.tag.id === typedTagToRemove.tag.id.toString() &&
        control.value.tagType === typedTagToRemove.tagType
    );

    if (index >= 0 && index < typedTagArray.controls.length) {
      typedTagArray.removeAt(index);
    }
  }

  if (surtitleControl && surtitleControl.controls[0]) {
    if (surtitleControl.controls[0].value.id === typedTagToRemove.tag.id) {
      surtitleControl.clear();
    }
  }
}

export function handleTagSelected(
  typedTagSelected: ITypedSelectListItem,
  typedTagsArray: FormArray<FormControl<ITypedSelectListItem>>
) {
  if (typedTagsArray) {
    const isDuplicate = typedTagsArray.controls.some(
      (control) =>
        control.value.tag.id === typedTagSelected.tag.id &&
        control.value.tagType === typedTagSelected.tagType
    );

    if (!isDuplicate) {
      const newControl = new FormControl(typedTagSelected);
      typedTagsArray.push(newControl);
    }
  }
}
